module.exports = __webpack_public_path__ + "static/media/system_img.06426d16.jpg";